<script setup="">
import { ChevronUpIcon } from "lucide-vue-next";

import Accordion from "@/Components/Accordion.vue";
import AccordionItem from "@/Components/AccordionItem.vue";

const navigation = {
  main: [
    { name: "공지사항", href: route("notices.index") },
    { name: "고객센터", href: "https://pf.kakao.com/_aLvxlG" },
    { name: "이용약관", href: route("terms.terms-of-service") },
    { name: "개인정보처리방침", href: route("terms.privacy-policy") }
  ]
};
</script>

<template>
  <footer class="px-4 py-12 isp-mb-0 sm:px-6 lg:px-8">
    <div class="mx-auto max-w-7xl">
      <nav aria-label="footer" class="flex flex-wrap justify-center">
        <div v-for="item in navigation.main" :key="item.name" class="px-2 sm:px-4">
          <a :href="item.href" class="text-xs text-600 hover:text-zinc-800 dark:hover:text-zinc-300" target="_blank">
            {{ item.name }}
          </a>
        </div>
      </nav>

      <Accordion>
        <AccordionItem>
          <template #trigger="{ open, isActive }">
            <div class="flex-center flex cursor-pointer space-x-2 py-4 text-500">
              <p class="text-center text-xs" @click="open">&copy; 2023 PURGO.</p>
              <ChevronUpIcon :class="[isActive ? '' : '-rotate-180']" class="h-4 w-4 transition-transform ease-in-out" @click="open" />
            </div>
          </template>

          <p class="flex-center flex-wrap gap-x-2 text-center text-xs text-500">
            <span>핀틀</span><span>|</span> <span>세종특별자치시 한누리대로 1824, 606</span><span>|</span>대표 : 이충일<span>|</span>
            <span>사업자등록번호 : 536-11-01106</span>
          </p>
        </AccordionItem>
      </Accordion>
    </div>
  </footer>
</template>
